// src/AdminBanner.js
// Вкладка «Баннер» в админ-панели — только для hlpurslf (BANNER_MANAGER на сервере).
// Включает баннер «Приложение в RuStore» на странице входа и вверху сайта.
import React, { useEffect, useState } from 'react';
import { api } from './api';
import { AppBannerView } from './AppBanner';
import './AdminUsers.css';
import './AdminBanner.css';

const FIELDS = [
  { name: 'title', label: 'Заголовок', max: 120 },
  { name: 'text', label: 'Текст', max: 300, multiline: true },
  { name: 'button_label', label: 'Надпись на кнопке', max: 40 },
  { name: 'url', label: 'Ссылка на приложение в RuStore', max: 500, placeholder: 'https://www.rustore.ru/catalog/app/online.rshi32.uchitelskaya' },
];

export default function AdminBanner({ onChanged }) {
  const [saved, setSaved] = useState(null);
  const [form, setForm] = useState(null);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [saving, setSaving] = useState(false);

  const apply = (data) => {
    setSaved(data);
    setForm({
      enabled: data.enabled,
      title: data.title || '',
      text: data.text || '',
      button_label: data.button_label || '',
      url: data.url || '',
    });
  };

  useEffect(() => {
    api.getAppBanner({ withAuth: true }).then(
      (data) => {
        if (data.can_manage) apply(data);
        else setError('Управлять баннером может только владелец сайта.');
      },
      (e) => setError(e.message),
    );
  }, []);

  if (error && !form) return <div className="admin-error">{error}</div>;
  if (!form) return <div className="admin-appcard-loading">Загружаем…</div>;

  const dirty = ['enabled', 'title', 'text', 'button_label', 'url'].some((k) => form[k] !== (saved[k] ?? (k === 'enabled' ? false : '')));

  const save = async (patch, okText) => {
    setSaving(true);
    setError(null);
    setMessage(null);
    try {
      apply(await api.updateAppBanner(patch));
      setMessage(okText);
      if (onChanged) onChanged();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  const toggle = () => {
    const enabled = !saved.enabled;
    save({ ...form, enabled }, enabled ? 'Баннер показан на сайте' : 'Баннер скрыт');
  };

  return (
    <div className="admin-appcard">
      <div className={`admin-appcard-status ${saved.enabled ? 'on' : 'off'}`}>
        <div>
          <strong>{saved.enabled ? 'Баннер показывается' : 'Баннер выключен'}</strong>
          <span>
            {saved.enabled
              ? 'На странице входа — под окном входа, у вошедших — полосой вверху страницы (её можно закрыть). На iPhone и iPad баннер не показывается: RuStore только для Android.'
              : 'Включите, когда приложение появится в RuStore.'}
          </span>
        </div>
        <button
          type="button"
          className={`admin-button ${saved.enabled ? 'admin-button-cancel' : 'admin-button-save'}`}
          onClick={toggle}
          disabled={saving}
        >
          {saved.enabled ? 'Выключить' : 'Включить'}
        </button>
      </div>

      <div className="admin-appcard-grid">
        <form
          className="admin-appcard-form"
          onSubmit={(e) => {
            e.preventDefault();
            save(form, 'Сохранено');
          }}
        >
          {FIELDS.map((f) => (
            <label key={f.name} className="admin-appcard-field">
              <span className="admin-appcard-label">
                {f.label}
                <span className="admin-appcard-counter">{form[f.name].length}/{f.max}</span>
              </span>
              {f.multiline ? (
                <textarea
                  rows={3}
                  maxLength={f.max}
                  value={form[f.name]}
                  onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
                />
              ) : (
                <input
                  type={f.name === 'url' ? 'url' : 'text'}
                  maxLength={f.max}
                  placeholder={f.placeholder}
                  value={form[f.name]}
                  onChange={(e) => setForm({ ...form, [f.name]: e.target.value })}
                />
              )}
            </label>
          ))}

          {error && <div className="admin-error">{error}</div>}
          {message && !error && <div className="admin-appcard-message">{message}</div>}

          <div className="admin-appcard-actions">
            <button type="submit" className="admin-button admin-button-save" disabled={saving || !dirty}>
              {saving ? 'Сохраняем…' : 'Сохранить'}
            </button>
            {dirty && (
              <button type="button" className="admin-button admin-button-cancel" onClick={() => apply(saved)} disabled={saving}>
                Отменить изменения
              </button>
            )}
          </div>
          <p className="admin-appcard-hint">
            После сохранения изменённый баннер снова появится у всех, кто его закрыл.
          </p>
        </form>

        <div className="admin-appcard-preview">
          <span className="admin-appcard-preview-title">Страница входа</span>
          <div className="admin-appcard-preview-login">
            <AppBannerView banner={form} variant="login" />
          </div>
          <span className="admin-appcard-preview-title">Сайт после входа</span>
          <div className="admin-appcard-preview-top">
            <AppBannerView banner={form} variant="top" onClose={() => {}} />
          </div>
        </div>
      </div>
    </div>
  );
}
